export function formatDate(strDate) {
  try {
    var strSplitDate = String(strDate).split(" ");
    var date = new Date(strSplitDate[0]);
    var dd = date.getDate();
    var mm = date.getMonth() + 1; //January is 0!

    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    date = dd + "/" + mm + "/" + yyyy;
    return date.toString();
  } catch (error) {
    return "";
  }
}
export function currentDate() {
  let currentDate1 = new Date();
  var dd = currentDate1.getDate();
  var mm = currentDate1.getMonth() + 1; //January is 0!
  var yyyy = currentDate1.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
}
export function tomorrowDate() {
  const today = new Date();
  let currentDate1 = new Date(today);
  currentDate1.setDate(today.getDate() + 1);
  var dd = currentDate1.getDate();
  var mm = currentDate1.getMonth() + 1; //January is 0!
  var yyyy = currentDate1.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
}
export function getDate(date) {
  try {
    if (!date) return "";
    var strSplitDate = String(date).split(" ");
    if (strSplitDate[0].indexOf("0001") > -1) {
      return "";
    }
    var dateNgayVay = new Date(
      strSplitDate[0].replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
    );
    if (dateNgayVay <= new Date(1900, 1, 1, 0, 0, 0, 0)) {
      return "";
    }
    return strSplitDate[0];
  } catch (error) {
    return "";
  }
}
export function convertDate(date) {
  if (date) {
    var strSplitDate = String(date).split(" ");
    var strDate = strSplitDate[0].replace(
      /(\d{2})\/(\d{2})\/(\d{4})/,
      "$2/$1/$3"
    );
    if (strDate.indexOf("1900") > -1) return null;
    var dateNgayVay = new Date(strDate);
    return dateNgayVay;
  } else {
    return "";
  }
}
export function formatDateTime(date) {
  var year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate();
  return day + "/" + month + "/" + year;
}
export function formatDayMonth(date) {
  if (date) {
    var year = date.getFullYear(),
      month = date.getMonth() + 1,
      day = date.getDate();
    if (month < 10 && day < 10) {
      return "0" + day + "/" + "0" + month + "/" + year;
    }
    if (month >= 10 && day >= 10) {
      return day + "/" + month + "/" + year;
    }
    if (month >= 10 && day < 10) {
      return "0" + day + "/" + month + "/" + year;
    }
    if (month < 10 && day >= 10) {
      return day + "/" + "0" + month + "/" + year;
    }
  } else {
    return "";
  }
}
export function GetDateHomQua() {
  const today = new Date();
  let currentDate1 = new Date(today);
  currentDate1.setDate(today.getDate() - 1);
  var dd = currentDate1.getDate();
  var mm = currentDate1.getMonth() + 1; //January is 0!
  var yyyy = currentDate1.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
}
// return an array of date objects for start (monday)
// and end (sunday) of week based on supplied
// date object or current date
export const startAndEndOfWeek = (date) => {
  // If no date object supplied, use current date
  // Copy date so don't modify supplied date
  var now = date ? new Date(date) : new Date();

  // set time to some convenient value
  now.setHours(0, 0, 0, 0);

  // Get the previous Monday
  var monday = new Date(now);
  monday.setDate(monday.getDate() - monday.getDay() + 1);

  // Get next Sunday
  var sunday = new Date(now);
  sunday.setDate(sunday.getDate() - sunday.getDay() + 7);

  // Return array of date objects
  return [monday, sunday];
};
export const startAndEndOfMonth = (date) => {
  var now = date ? new Date(date) : new Date();
  var firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  var lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return [firstDay, lastDay];
};

export const startAndEndOfYear = (date) => {
  var now = date ? new Date(date) : new Date();
  var firstDay = new Date(now.getFullYear(), 0, 1);
  var lastDay = new Date(now.getFullYear(), 11, 31);
  return [firstDay, lastDay];
};
export function currentDateV2(currentDate1) {
  var dd = currentDate1.getDate();
  var mm = currentDate1.getMonth() + 1; //January is 0!
  var yyyy = currentDate1.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
}

export function formatDateV2(dateStr) {
  let d = new Date(dateStr);
  let day = String(d.getDate()).padStart(2, "0");
  let month = String(d.getMonth() + 1).padStart(2, "0");
  let year = d.getFullYear();
  return `${day}/${month}/${year}`;
}
export const addOneMonthKeepDay = (dateStr) => {
  // tách ngày / tháng / năm
  const date1 = dateStr.split(" ")[0];
  const [day, month, year] = date1.split("/").map(Number);

  // tạo date với ngày = 1 trước để tránh lỗi nhảy tháng
  const d = new Date(year, month - 1 + 1, 1);

  // set lại ngày (nếu tháng đó không đủ ngày -> tự điều chỉnh về cuối tháng)
  d.setDate(day);

  // format lại dd/MM/yyyy
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};
export const addOneMonthKeepDay1 = (date) => {
  // tách ngày / tháng / năm
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // tạo date với ngày = 1 trước để tránh lỗi nhảy tháng
  const d = new Date(year, month, 1);

  // set lại ngày (nếu tháng đó không đủ ngày -> tự điều chỉnh về cuối tháng)
  d.setDate(day);

  // format lại dd/MM/yyyy
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};
